import React, { useCallback } from 'react';
import { PublicLayout } from 'new-design/layouts';
import { Box, Typography } from '@material-ui/core';
import { useQueryParams } from 'new-design/hooks/useQueryParams';
import IntlMessages from 'util/IntlMessages';
import Card from 'new-design/components/Card';
import { Button } from 'new-design/common/ui';
import { useHistory } from 'react-router';

export const SsoLoginPage = () => {
  const history = useHistory();
  const { errorCode } = useQueryParams();

  const handleContinueClick = useCallback(() => {
    history.push('/login');
  }, []);

  return (
    <PublicLayout disableRedirect>
      {errorCode && (
        <Card style={{ width: '50%' }}>
          <Typography>
            <IntlMessages id={errorCode} />
          </Typography>
          <Box mt={2}>
            <Button variant="contained" color="primary" onClick={handleContinueClick}>
              <IntlMessages id="continue" />
            </Button>
          </Box>
        </Card>
      )}
    </PublicLayout>
  );
};
